import { FaCheckCircle } from "react-icons/fa";
import { NavBar } from "../../components/NavBar";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../providers/GlobalProvider";
import { api } from "../../api/api";
import { CiNoWaitingSign } from "react-icons/ci";
import { Toast } from "../../utils/toast";
import FileBase64 from '../../components/FileBase64';
import './style.css';

function Card({
  nameCourse,
  isPedding,
  name,
  phone,
  downloadContract,
  downloadBoleto,
  data,
  isBoleto,
  isContract,
  loadingDownloadContract
}) {
  const documentsValids = Object.keys(data?.documentsApproved.documentsValids ?? {}).filter((key) => {
    return data?.documentsApproved.documentsValids[key] === false
  })

  const [documentsSend, setDocumentsSend] = useState([])

  return (
    <article className="enrollment-card surface-card">
      <header className="enrollment-header">
        <div>
          <span>Matrícula</span>
          <h2>{nameCourse}</h2>
        </div>
        <div className={`status-pill ${isPedding ? 'pending' : 'approved'}`}>
          {isPedding ? <CiNoWaitingSign size={18} /> : <FaCheckCircle size={18} />}
          {isPedding ? 'Pendente' : 'Aprovada'}
        </div>
      </header>

      <div className="enrollment-summary">
        <div>
          <p >Nome: <b>{name}</b></p>
          <p>Telefone: <b>{phone}</b></p>
          <p>Status da Matrícula: <b>{isPedding ? 'Pendente' : `Parabéns! Sua matrícula foi aprovada com sucesso. Estamos felizes em tê-lo(a) conosco!

Agora, você pode acessar o contrato para assinatura e também os boletos de pagamento do curso. Basta clicar nos links abaixo para fazer o download e dar continuidade ao processo.`}</b></p>
          {isPedding && <p>Motivo: <b className="text-danger">{data?.documentsApproved?.observation}</b> </p>}
        </div>
        <img className="enrollment-illustration" src="/img/1_y0r718mO33GhYsTIT2wvGQ.gif" alt="Aluno estudando" />
      </div>

      <div className="documents-review">
        {documentsValids.map((doc) => {
          const aux = {
            rgresp: 'RG do responsável',
            rgFiador: 'RG do fiador [Frente]',
            cpfresp: 'CPF do responsável',
            cpfFiador: 'CPF do fiador',
            'rgresp-verso': 'RG do responsavel [Verso]',
            'rgFiador-verso': 'RG do fiador [Verso]',
            comproResiResp: 'Comprovante de residência do responsável',
            comproResiFiador: 'Comprovante de residência do fiador',
            pix: 'Pix',
            rg: 'RG do aluno [Frente]',
            'rg-verso': 'RG do aluno [Verso]',
            cpf: 'CPF do aluno',
            compResi: 'Comprovante de residência do aluno',
            compResiOrigem: 'Comprovante de residência do aluno (cidade de origem)',
          };

          return (
            <div className="document-upload" key={doc}>
              <label htmlFor="">{aux[doc]}</label>
              <br />
              <FileBase64
                multiple={false}
                onDone={async function (e) {

                  setDocumentsSend(state => {
                    state.push({
                      id: data?.documentsApproved?.studentCourseId,
                      documents: [
                        {
                          base64: `${e.base64}`,
                          name: e.name,
                          key: doc
                        }
                      ]
                    })

                    return state
                  })
                }} />
            </div>
          )
        })}

        {documentsValids.length > 0 && <button className="btn btn-primary mb-2"
          onClick={async () => {
            Toast.imgToast();
            for await (const item of documentsSend) {
              await api.post('/api/v1/files/base64', item)
            }

            Toast.success("Arquivos enviados com sucesso")
          }}>
          Enviar documentos
        </button>}
      </div>

      <div className="enrollment-actions">
        <button className={`btn btn-outline-${isContract ? 'success' : 'primary'}`} onClick={() => downloadContract()}>
          {loadingDownloadContract ? (
            <div className="spinner-border" role="status">
              <span className="visually-hidden"></span>
            </div>
          ) : 'Baixar Contrato'}
        </button>
        <button className={`btn btn-outline-${isBoleto ? 'success' : 'secondary'}`} onClick={() => downloadBoleto()}>Baixar boleto</button>
      </div>
    </article>
  )
}

export function MatriculasPage() {
  const { student } = useContext(GlobalContext)
  const [loading, setLoading] = useState(true)
  const [loadingDownloadContract, setLoadingDownloadContract] = useState(false)
  const [matriculas, setMatriculas] = useState([])

  async function getMatriculas() {
    const response = await api.get('/api/v1/students/' + student.id)

    setMatriculas(response.data.studentCourse.filter(e => e.referenceCourses.length === 0))
    setLoading(false)
  }

  async function downloadContract(courseId, studentId) {
    try {
      setLoadingDownloadContract(true)
      const response = await api.get(`/api/v1/contracts/render/${studentId}/${courseId}`, {
        responseType: 'blob'
      })

      if (response.data.isDefault) {
        return Toast.warning('Seu contrato ainda não foi gerado, aguarde até o mesmo ser concluido.', 'Aguarde')
      }

      const href = URL.createObjectURL(response.data);

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'contrato.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } catch (error) {
      if (error.response.data.includes('Contrato não disponivel')) {
        return Toast.warning('Contrato não disponível', 'Atenção')
      }

      Toast.error('Entre em contato com o omega para mais informações', 'Obrigado')
    } finally {
      setLoadingDownloadContract(false)
    }
  }

  async function downloadBoleto(idMatricula) {
    const response = await api.get(`/api/v1/files/download?refId=${idMatricula}&fileType=boleto&typeRef=student-course`)

    if (!response.data.url) {
      return Toast.warning('Boleto ainda não gerado', '')
    }

    const link = document.createElement('a');
    link.href = response.data.url;
    link.target = '_blank'
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  }

  useEffect(() => {
    if (student?.id) {
      getMatriculas()
    }
  }, [student?.id])

  return (
    <>
      <NavBar>
        <div>
          <div className="page-heading">
            <div>
              <h1>Minhas matrículas</h1>
              <p>Acompanhe aprovações, documentos, contratos e boletos.</p>
            </div>
          </div>

          <div className="enrollments-list">

            {loading && (
              <div className="empty-state surface-card">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden"></span>
                </div>
                <p className="mt-3 mb-0">Carregando matrículas...</p>
              </div>
            )}
            {!loading && matriculas.length === 0 && (
              <div className="empty-state surface-card">Você ainda não possui matrículas.</div>
            )}

            {!loading && (
              matriculas.map((matricula) => {
                return (
                  <Card
                    isPedding={['pendente', 'reprovado'].includes(matricula.documentsApproved.status)}
                    name={student.name}
                    nameCourse={matricula.courseName}
                    phone={student.phone}
                    isBoleto={matricula.isBoleto}
                    isContract={matricula.isContract}
                    key={matricula.id}
                    downloadContract={async () => await downloadContract(matricula.courseId, matricula.studentId)}
                    downloadBoleto={async () => await downloadBoleto(matricula.id)}
                    data={matricula}
                    loadingDownloadContract={loadingDownloadContract}
                  />
                )
              })
            )}
          </div>
        </div>
      </NavBar>
    </>
  )
}
